export const aboutData = {
  brandName: '芒果视频',
  brandIntro: [
    '芒果视频成立于2020年，是一家致力于为用户提供高品质在线影视观看体验的互联网平台。我们始终秉持"高清画质、流畅体验、免费观看"的核心理念，为数千万用户提供电影、电视剧、综艺、动漫、纪录片等丰富多元的影视内容。',
    '在视频画质方面，芒果视频全线支持1080P超清画质播放，采用先进的H.265编码技术和智能CDN加速节点，确保用户无论身在何处，都能享受流畅不卡顿的观影体验。我们深知在这个内容为王的时代，画质和流畅度是用户体验的基石。',
    '芒果视频的内容库涵盖国内外热门电影、口碑电视剧、人气综艺、精品动漫和高分纪录片，每日持续更新最新资源。无论是院线大片、热播剧集，还是经典老片，用户都能在芒果视频找到心仪的内容。',
  ],
  features: [
    {
      icon: 'ri-4k-line',
      title: '1080P超清画质',
      desc: '全站支持1080P高清播放，H.265高效编码，画面清晰细腻，色彩真实还原。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '流畅不卡顿',
      desc: '全球CDN加速节点覆盖，智能自适应码率技术，弱网环境也能流畅播放。',
    },
    {
      icon: 'ri-movie-line',
      title: '海量资源库',
      desc: '电影、电视剧、综艺、动漫、纪录片全覆盖，每日更新最新热门内容。',
    },
    {
      icon: 'ri-device-line',
      title: '多端兼容',
      desc: '支持电脑、平板、手机在线观看，无需下载APP，浏览器即开即看。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      desc: '严格内容审核机制，绿色健康的观影环境，保护用户信息安全。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '用户至上',
      desc: '7×24小时客服支持，用户反馈快速响应，持续优化观影体验。',
    },
  ],
  stats: [
    { value: '5000万+', label: '累计用户' },
    { value: '10万+', label: '影视资源' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.8', label: '用户评分' },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '影视爱好者',
      content: '芒果视频的画质真的很棒！比起香蕉视频和红桃视频，芒果的1080P超清画质明显更清晰，而且真的不卡顿。现在看剧就看芒果视频了。',
      rating: 5,
    },
    {
      name: '李女士',
      role: '追剧达人',
      content: '资源更新速度很快，热门电视剧几乎和电视台同步更新。界面简洁干净，没有烦人的广告弹窗，观影体验非常好。',
      rating: 5,
    },
    {
      name: '王同学',
      role: '大学生',
      content: '动漫资源很全，国漫日漫都有，画质清晰流畅。宿舍网络不太好，但芒果视频的自动适配功能让我看得很流畅。强烈推荐！',
      rating: 5,
    },
    {
      name: '赵先生',
      role: '电影发烧友',
      content: '作为一个重度电影爱好者，芒果视频的片库让我惊喜。从经典老片到最新大片，分类清晰，搜索方便。1080P画质看大片太过瘾了。',
      rating: 4,
    },
  ],
  contact: {
    email: 'contact@mangovideo.com',
    wechat: 'mangovideo_official',
    qq: '800123456',
    address: '广东省深圳市南山区科技园芒果视频大厦',
    phone: '400-888-0000',
  },
};